export interface SortRule {
  col: string
  dir: 'asc' | 'desc'
}

export function sortRows<T extends Record<string, unknown>>(rows: T[], rules: SortRule[]): T[] {
  if (rules.length === 0) return rows
  return [...rows].sort((a, b) => {
    for (const { col, dir } of rules) {
      const av = a[col], bv = b[col]
      let cmp = 0
      if (typeof av === 'number' && typeof bv === 'number') cmp = av - bv
      else cmp = String(av ?? '').localeCompare(String(bv ?? ''))
      if (cmp !== 0) return dir === 'asc' ? cmp : -cmp
    }
    return 0
  })
}
